module.exports = __webpack_public_path__ + "static/media/4. Darius.855d38a7.png";